import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./gallery.css";

export const GalleryHome = () => {
  const [GalleryUser, setGalleryUser] = useState([]);
  const [viewProduct, setviewProduct] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPoints = async () => {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/gallery_list"
      );
      setGalleryUser(response.data.data);
    };

    fetchPoints();
  }, []);

  const handleDelete = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_gallery",
        { gallery_id: userId }
      );

      if (response.data.success === "1") {
        setGalleryUser((prevUser) =>
          prevUser.filter((user) => user.gallery_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Gallery")
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Attribute.");
    }
  };

  return (
    <div className="container">
      <div className="row pt-5">
        <div className="col-lg-10 slider-home">
          <div>
            <h3 className="slider-heading">Gallery Image</h3>
            <Link to="/Gallery-add">
              <button className="add-button btn-success">
                Add Gallery
              </button>
            </Link>
          </div>
          <div className="row image-details">
            {GalleryUser.map((user) => {
              return (
                <div className="col-lg-4 slider-image">
                  <img
                    src={`https://cyberathon.com/silverapartment/${user.images}`}
                    alt="Gallery Image"
                  />
                  <div className="icons">
                    <ul>
                      <li>
      
                        <button
                          className="btn btn-sm btn-info"
                          onClick={() => {
                            setviewProduct(user);
                            setShowViewModal(true);
                          }}
                        >
                          <i className="fa-regular fa-eye text-white"></i>
                        </button>
                      </li>
                      <li>
                        <Link to={`/Gallery-edit/` + user.gallery_id} className="btn btn-sm btn-primary">
                          <i
                            className="fa-regular fa-pen-to-square"
                            title="Edit"
                          >
                          </i>
                        </Link>
                      </li>
                      <li>
                        <span onClick={() => handleDelete(user.gallery_id)} className="btn btn-sm btn-danger">
                          <i class="fa-regular fa-trash-can" title="Delete">
                          </i>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* Modal */}
      {viewProduct && (
        <div
          className={`modal fade ${showViewModal ? "show d-block" : ""}`}
          tabIndex="-1"
           style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-white">Gallery</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowViewModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {viewProduct.images && (
                  <img
                    src={`https://cyberathon.com/silverapartment/${viewProduct.images}`}
                    alt="Banner"
                    className="img-fluid rounded"
                  />
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowViewModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const AddGallery = () => {
  const [GalleryImage, setGalleryImage] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
      const maxSize = 1 * 1024 * 1024;

      if (!validTypes.includes(file.type)) {
        setError(
          "Invalid file type. Only JPG, JPEG, WEBP and PNG are allowed."
        );
        setGalleryImage(null);
        return;
      }

      if (file.size > maxSize) {
        setError("File size exceeds 1MB. Please upload a smaller file.");
        setGalleryImage(null);
        return;
      }

      setError("");
      setGalleryImage(file);
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!GalleryImage) {
      setError("Please select a valid image file before submitting.");
      return;
    }

    const formData = new FormData();
    if (GalleryImage) {
      formData.append("gallery_images", GalleryImage);
    }

    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_gallery",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Data Added Successfully!");
      navigate("/Gallery");
    } catch (error) {
      toast.error("There was an error adding the Gallery!");
      console.error("Error:", error);
    }
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header table-custom text-white">
        <h4 className="mb-0 text-white text-center">Add Gallery Image</h4>
      </div>
      <div className="card-body adduser">
        <Link to="/Gallery">
          <i className="fa-solid fa-xmark"></i>
        </Link>
        <form className="row g-3" onSubmit={submitForm}>
          <p style={{ color: "red" }}>
            Image must be at least Width-100% Height-500 pixels!
          </p>
          <div className="col-md-4">
            <label htmlFor="image" className="form-label">
              Image
            </label>
            <input
              type="file"
              className="form-control"
              id="images"
              onChange={handleFileChange}
            />
          </div>
          {error && <small style={{ color: "red" }}>{error}</small>}
          <br />

          <div className="col-12 d-flex justify-content-end"  style={{height:"40px"}}>
            <button
              type="submit"
              className="btn btn-success text-white"
              onSubmit={submitForm}
            >
              Add Image
            </button>
            <div className="mb-3 ms-1">
              <Link to="/Gallery" className="btn btn-secondary text-white">
                Back
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const EditGallery = () => {
  const [GalleryImage, setGalleryImage] = useState(null);
  const [error, setError] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const editData = async () => {
      try {
        const response = await axios.post(
          `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/gallery_list/${id}`
        );
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    editData();
  }, [id]);

  const validateImage = (file) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
    const maxSize = 1 * 1024 * 1024;

    if (!allowedTypes.includes(file.type)) {
      setError("Invalid file type. Only JPG, JPEG, WEBP and PNG are allowed.");
      return false;
    }

    if (file.size > maxSize) {
      setError("File size exceeds the 1MB limit.");
      return false;
    }

    setError("");
    return true;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && validateImage(file)) {
      setGalleryImage(file);
    } else {
      setGalleryImage(null);
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!GalleryImage) {
      setError("Please select a valid image file before submitting.");
      return;
    }

    const formData = new FormData();
    formData.append("gallery_images", GalleryImage);
    formData.append("gallery_id", id); // very important

    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_gallery",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.info("Data Updated Successfully!");
      navigate("/Gallery");
    } catch (error) {
      toast.error("Error updating gallery image");
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header table-custom text-white justify-content-center">
              <h5 className="modal-title">Update Gallery Image</h5>
            </div>

            <div className="mb-3">
              <label className="form-label">
                Image{" "}
                <span className="text-danger">
                  (Image must be at least 90x100%)
                </span>
              </label>
              <input
                type="file"
                className="form-control"
                onChange={handleFileChange}
              />
            </div>

            <div className="modal-footer">
              <Link to="/Gallery">
              <button
                type="submit"
                className="btn btn-success text-white"
                onSubmit={submitForm}
              >
                Update
              </button>
                <button
                  type="button"
                  className="btn btn-secondary text-white ms-1"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </Link>
            </div>
          </div>
          {error && <small style={{ color: "red" }}>{error}</small>}
          <br />
        </form>
      </div>
    </div>
  );
};

export const ViewGallery = () => {
  const [GalleryUser, setGalleryUser] = useState({
    images: "",
  });
  const { gallery_id } = useParams();

  useEffect(() => {
    const GalleryData = async () => {
      try {
        const response = await axios.get(
          `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/gallery_list/${gallery_id}`
        );
        setGalleryUser(response.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    GalleryData();
  }, [gallery_id]);

  return (
    <div className="view-image">
      <Link to="/gallery">
        <i className="fa-solid fa-xmark"></i>
      </Link>
      <img
        src={`https://api.gosaviadvanceddentalclinic.com/images/${GalleryUser.images}`}
        alt="Gallery"
      />
    </div>
  );
};
